import { useContext } from "react"
import PropTypes from "prop-types"
import { AutoAwesome } from "@mui/icons-material"
import Button from "components/material/button"
import { useIsAiChatFeatureEnabled } from "resources/account"
import { useResourceCurrency } from "resources/currencies"
import { useModelMetadata } from "resources/models"
import { usePositionSetMetadata } from "resources/position-sets"
import AiTeammate from "../.."
import "./style.scss"

export default function AiToggleButton({ context }) {
  const dashboardContext = useContext(context)
  const { isAiDrawerOpen, setIsAiDrawerOpen, isPreferencesLoaded } = dashboardContext
  const isAiChatFeatureEnabled = useIsAiChatFeatureEnabled()

  const [modelMetadata] = useModelMetadata(dashboardContext.modelId)
  const [resourceMetadata] = usePositionSetMetadata(dashboardContext.modelId, dashboardContext.instrument, modelMetadata?.availability?.currentDate)
  const [benchmarkMetadata] = usePositionSetMetadata(dashboardContext.modelId, dashboardContext.base, modelMetadata?.availability?.currentDate)
  const [currency] = useResourceCurrency(dashboardContext.modelId, dashboardContext.instrument)

  const handleToggle = () => {
    const newState = !isAiDrawerOpen
    setIsAiDrawerOpen(newState)
  }

  const title = isAiChatFeatureEnabled ? "AI Teammate" : "Quick Answers"

  function handleDrawerClose() {
    setIsAiDrawerOpen(false)
  }

  return <>
    <Button
      onClick={handleToggle}
      size="medium"
      color="primary"
      variant="contained"
      className="ai-toggle-button"
      disabled={!isPreferencesLoaded}
      tooltip={isPreferencesLoaded ? title : `${title} (Loading...)`}
    >
        <AutoAwesome className="ai-toggle-button-icon" />
    </Button>
    {isAiChatFeatureEnabled && <AiTeammate
      isOpen={isAiDrawerOpen}
      onClose={handleDrawerClose}
      modelId={dashboardContext.modelId}
      instrument={dashboardContext.instrument}
      base={dashboardContext.base}
      modelMetadata={modelMetadata}
      resourceMetadata={resourceMetadata}
      benchmarkMetadata={benchmarkMetadata}
      currency={currency}
      startDate={dashboardContext.startDate}
      endDate={dashboardContext.endDate}
    />}
  </>
}

AiToggleButton.propTypes = {
  context: PropTypes.object.isRequired,
}
